<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 390px">
      <!-- header-->
      <v-container class="chart-header d-flex flex-column pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("actualVsTargetProduction") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 gray--text">
          {{ $t("receiptsVsPaymentsLastSixMonths") }}
        </v-card-text>
      </v-container>

      <!-- line chart-->
      <apexchart
        type="line"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "RealProduction",
  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {
      chartApiResponse: {
        data: {
          categories: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور"],
          peyment: {
            total: [280, 30, 2900000, 91600, 2600000, 2800],
          },
          receipt: {
            total: [28000, 3000000, 29000, 910000, 26000, 2800],
          },
        },
      },
    };
  },

  computed: {
    chartSeries() {
      return [
        {
          name: "تولید واقعی",
          data: this.chartApiResponse.data.peyment.total,
        },
        {
          name: "هدف",
          data: this.chartApiResponse.data.receipt.total,
        },
      ];
    },

    chartOptions() {
      return {
        chart: {
          type: "line",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        colors: ["#14B8A6", "#EF4444"],

        stroke: {
          curve: "smooth",
          width: [2, 2],
          dashArray: [0, 6],
        },

        markers: {
          size: 5,
          colors: ["#14B8A6", "#EF4444"],
          strokeColors: "#ffffff",
          strokeWidth: [2, 2],
          hover: {
            size: 6,
          },
        },

        xaxis: {
          categories: this.chartApiResponse.data.categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          min: 0,
          labels: {
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -50 : 0,
            formatter: (value) => `${this.$numberFormat(value)} م.ت`,
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        tooltip: {
          y: {
            formatter(val) {
              return val.toLocaleString("fa-IR") + " تومان";
            },
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
